// store/slices/dataSlice.js
import { createSlice } from '@reduxjs/toolkit';

const dataSlice = createSlice({
  name: 'data',
  initialState: {
    value: null,  // or [] or {} depending on your data
  },
  reducers: {
    setData: (state, action) => {
      state.value = action.payload;
    },
    clearData: (state) => {
      state.value = null;
    },
  },
});

export const { setData, clearData } = dataSlice.actions;

export default dataSlice.reducer;